import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HtmlSanitizerPipe } from './pipes';

@NgModule({
    imports: [CommonModule],
    declarations: [HtmlSanitizerPipe],
    exports: [HtmlSanitizerPipe],
})
export class EcmMaterialPipeModule {}
